export const DEFAULT_SPRING_TYPE = {
  id: 1,
  name: 'Пружины сжатия'
}

export const FLAG_ID_STAGE_SHIPPED = 5
